import { listItemButtonClasses, listItemTextClasses } from '@mui/material';

import { SxProp } from 'src/types/mui';

export const navListItemStyles: SxProp = {
  borderRadius: '8px',
  padding: '8px 8px',
  color: 'slate.300',
  [` .${listItemTextClasses.root}`]: {
    color: 'black',
  },
  [`.${listItemButtonClasses.selected}`]: {
    [` .${listItemTextClasses.root}`]: {
      color: 'text.primary',
    },
  },
  [` .${listItemButtonClasses.root}`]: {
    borderRadius: '8px',
  },
};
